import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/admin/app';
import AdminPage from 'flarum/admin/components/AdminPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tooltip from 'flarum/common/components/Tooltip';
import ExtensionLink from './ExtensionLink';
import LinkButton from 'flarum/common/components/LinkButton';
import Form from 'flarum/common/components/Form';
export default class GdprPage extends AdminPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "gdprDataTypes", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadGdprDataTypes();
  }
  headerInfo() {
    return {
      className: 'GdprPage--header',
      icon: 'fas fa-user-shield',
      title: app.translator.trans('flarum-gdpr.admin.gdpr_page.heading'),
      description: app.translator.trans('flarum-gdpr.admin.gdpr_page.description')
    };
  }
  loadGdprDataTypes() {
    this.loading = true;
    app.store.find('gdpr-datatypes').then(dataTypes => {
      this.gdprDataTypes = dataTypes;
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m(LoadingIndicator, null);
    }
    return m("div", {
      className: "GdprPage"
    }, m(Form, null, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-gdpr.admin.gdpr_page.settings.heading')), m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.settings.help_text')), m(LinkButton, {
      className: "Button",
      href: app.route('extension', {
        id: 'flarum-gdpr'
      })
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.settings.extension_settings_button'))), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.title')), m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.help_text')), this.grid()), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-gdpr.admin.gdpr_page.user_table_data.title')), m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.user_table_data.help_text')), m("div", {
      className: "GdprUserColumnData"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.user_table_data.not_yet_implemented')))));
  }
  grid() {
    return m("div", {
      className: "GdprGrid"
    }, m("div", {
      class: "GdprGrid-row"
    }, m("div", {
      className: "GdprGrid-header"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.type')), m("div", {
      className: "GdprGrid-header"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.export_description')), m("div", {
      className: "GdprGrid-header"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.anonymize_description')), m("div", {
      className: "GdprGrid-header"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.delete_description')), m("div", {
      className: "GdprGrid-header"
    }, app.translator.trans('flarum-gdpr.admin.gdpr_page.data_types.extension'))), this.gdprDataTypes.map(dataType => m('[', null, m("div", {
      class: "GdprGrid-row"
    }, m("div", null, m(Tooltip, {
      text: dataType.id()
    }, m("span", {
      className: "helpText"
    }, dataType.type()))), m("div", {
      className: "helpText"
    }, dataType.exportDescription()), m("div", {
      className: "helpText"
    }, dataType.anonymizeDescription()), m("div", {
      className: "helpText"
    }, dataType.deleteDescription()), m("div", null, m(ExtensionLink, {
      extension: dataType.extension() ? app.data.extensions[dataType.extension()] : null
    }))))));
  }
}
flarum.reg.add('flarum-gdpr', 'admin/components/GdprPage', GdprPage);